module.exports = __webpack_public_path__ + "static/media/shareGoogle.997c59f0.svg";